import moment from "moment";

const chart_data = {
  line_chart_data: {
    chart_options: {
      chart: {
        toolbar: {
          show: true,
          export: {
            csv: {
              filename: `${moment().format('DD/MM/YYYY HH-mm')} Sales Revenue`,
            },
            svg: {
              filename: `${moment().format('DD/MM/YYYY HH-mm')} Sales Revenue`,
            },
            png: {
              filename: `${moment().format('DD/MM/YYYY HH-mm')} Sales Revenue`,
            }
          },
          tools: {
            download: true,
            selection: true,
            zoom: false,
            zoomin: true,
            zoomout: true,
            pan: true,
            customIcons: []
          },
        },
        dropShadow: {
          enabled: true,
          top: 5,
          left: 0,
          blur: 4,
          opacity: 0.10
        }
      },
      stroke: {
        curve: 'smooth',
        dashArray: 0,
        width: 5
      },
      grid: {
        show: true,
        borderColor: '#e7e7e7',
        xaxis: {
          lines: {
            show: true
          }
        },
        yaxis: {
          lines: {
            show: true
          }
        },
      },
      legend: {
        show: true
      },
      colors: ['#39b24b', '#b8c2cc'],
      markers: {
        size: 5,
        hover: {
          size: 8
        }
      },
      xaxis: {
        categories: [],
        title: {
          text: 'Time'
        },
        labels: {
          style: {
            cssClass: 'text-grey fill-current'
          }
        },
        axisTicks: {
          show: false
        },
        axisBorder: {
          show: false
        }
      },
      yaxis: {
        title: {
          text: ''
        },
        tickAmount: 5,
        labels: {
          style: {
            cssClass: 'text-grey fill-current'
          },
          formatter: (val) => {
            return val > 999 ? `${(val / 1000).toFixed(1)}k` : val
          }
        }
      },
      tooltip: {
        x: {show: true}
      }
    },
    series: [{ name: '', data: [] }],
  },
  pie_chart_data: {
    chart_options: {
      chart: {
        width: 400,
        type: 'pie',
      },
      labels: [],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
    series: [],
  },
}

export default chart_data;
